import { useState } from 'react';

type DragAndDropProps = {
  isDisabled: boolean;
  onFilesDrop: (files: FileList) => void;
};

export const useDragAndDrop = ({ isDisabled, onFilesDrop }: DragAndDropProps) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragEvent = (e: React.DragEvent, isDrag: boolean) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isDisabled) {
      setIsDragging(isDrag);
    }
  };

  const handleDrop = async (e: React.DragEvent) => {
    if (isDisabled) return;
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    onFilesDrop(e.dataTransfer.files);
  };

  const getDragProps = () => {
    if (isDisabled) {
      return {};
    }

    return {
      onDragEnter: (e: React.DragEvent) => handleDragEvent(e, true),
      onDragLeave: (e: React.DragEvent) => handleDragEvent(e, false),
      onDragOver: (e: React.DragEvent) => handleDragEvent(e, true),
      onDrop: handleDrop,
    };
  };

  return {
    isDragging,
    dragProps: getDragProps(),
  };
};
